'use client';

import { c as _c } from "react/compiler-runtime";
import { Bicycle } from '@phosphor-icons/react';
import { normalizeDate } from '@utils/helpers';
import { formatDateWithShortWeekday } from '@utils/utils-format';
import { DEFAULT_TIME_ZONE } from '@/lib/time-zone';
import { useBeachChairModel } from '../hooks/use-beach-chair-model';
import { AddedToCartItemDetails, AddedToCartItemImage } from './added-to-cart-item-details';
import type { AccommodationItem as AccommodationItemType, AddedToCartItem as AddedToCartItemType, BeachChairItem as BeachChairItemType, BikeItem as BikeItemType, ExperienceItem as ExperienceItemType } from './atoms/added-to-cart-items.atom';
type AddedToCartItemProps = {
  item: AddedToCartItemType;
};
export function AddedToCartItem(t0) {
  const $ = _c(8);
  const {
    item
  } = t0;
  switch (item.type) {
    case "accommodation":
      {
        let t1;
        if ($[0] !== item) {
          t1 = <AccommodationItem item={item} />;
          $[0] = item;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "experience":
      {
        let t1;
        if ($[2] !== item) {
          t1 = <ExperienceItem item={item} />;
          $[2] = item;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "beachChair":
      {
        let t1;
        if ($[4] !== item) {
          t1 = <BeachChairItem item={item} />;
          $[4] = item;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "bike":
      {
        let t1;
        if ($[6] !== item) {
          t1 = <BikeItem item={item} />;
          $[6] = item;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}
type AccommodationItemProps = {
  item: AccommodationItemType;
};
function AccommodationItem(t0) {
  const $ = _c(6);
  const {
    item
  } = t0;
  const timeRange = useItemTimeRange(item.startDate, item.endDate, item.startTimezone, item.endTimezone);
  let t1;
  if ($[0] !== item.image) {
    t1 = <AddedToCartItemImage image={item.image} />;
    $[0] = item.image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== item.name || $[3] !== t1 || $[4] !== timeRange) {
    t2 = <AddedToCartItemDetails title={item.name} subTitle={timeRange} image={t1} />;
    $[2] = item.name;
    $[3] = t1;
    $[4] = timeRange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
type ExperienceItemProps = {
  item: ExperienceItemType;
};
function ExperienceItem(t0) {
  const $ = _c(14);
  const {
    item
  } = t0;
  const dateRange = useItemTimeRange(item.startDate, item.endDate, item.startTimezone, item.endTimezone);
  let t1;
  if ($[0] !== dateRange || $[1] !== item.timeRange) {
    t1 = [dateRange, item.timeRange].filter(Boolean);
    $[0] = dateRange;
    $[1] = item.timeRange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const dateLine = t1.join(", ");
  let t2;
  if ($[3] !== dateLine) {
    t2 = dateLine && <>{dateLine} <br /></>;
    $[3] = dateLine;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== item.tickets || $[6] !== t2) {
    t3 = <>{t2}{item.tickets}</>;
    $[5] = item.tickets;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== item.image) {
    t4 = <AddedToCartItemImage image={item.image} />;
    $[8] = item.image;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== item.name || $[11] !== t3 || $[12] !== t4) {
    t5 = <AddedToCartItemDetails title={item.name} subTitle={t3} image={t4} />;
    $[10] = item.name;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
type BeachChairItemProps = {
  item: BeachChairItemType;
};
function BeachChairItem(t0) {
  const $ = _c(9);
  const {
    item
  } = t0;
  const {
    getBeachChairType
  } = useBeachChairModel();
  const timeRange = useItemTimeRange(item.startDate, item.endDate, item.startTimezone, item.endTimezone);
  let t1;
  if ($[0] !== getBeachChairType || $[1] !== item.name) {
    t1 = getBeachChairType(item.name);
    $[0] = getBeachChairType;
    $[1] = item.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const title = t1;
  let t2;
  if ($[3] !== item.image) {
    t2 = <AddedToCartItemImage image={item.image} />;
    $[3] = item.image;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2 || $[6] !== timeRange || $[7] !== title) {
    t3 = <AddedToCartItemDetails title={title} subTitle={timeRange} image={t2} />;
    $[5] = t2;
    $[6] = timeRange;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
type BikeItemProps = {
  item: BikeItemType;
};
function BikeItem(t0) {
  const $ = _c(11);
  const {
    item
  } = t0;
  const timeRange = useItemTimeRange(item.startDate, item.endDate, item.startTimezone, item.endTimezone);
  const {
    bikeCount,
    extrasCount
  } = item.products;
  const t1 = `${bikeCount}x Fahrrad`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== extrasCount) {
    t3 = extrasCount > 0 && <>{`${extrasCount}x Extras`} <br /></>;
    $[1] = extrasCount;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3 || $[5] !== timeRange) {
    t4 = <>{t1} {t2}{t3}{timeRange}</>;
    $[3] = t1;
    $[4] = t3;
    $[5] = timeRange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex h-full w-full items-center justify-center rounded-xl bg-sand"><Bicycle className="size-10" /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== item.name || $[9] !== t4) {
    t6 = <AddedToCartItemDetails title={item.name} subTitle={t4} image={t5} />;
    $[8] = item.name;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
const useItemTimeRange = (startDate?: string | null, endDate?: string | null, startTimezone?: string | null, endTimezone?: string | null) => {
  const startZone = startTimezone ?? DEFAULT_TIME_ZONE;
  const endZone = endTimezone ?? startZone;
  if (!startDate) {
    return '';
  }
  const parsedStart = normalizeDate(startDate, startZone);
  const parsedEnd = normalizeDate(endDate, endZone);
  const formattedStart = parsedStart ? formatDateWithShortWeekday(parsedStart, startZone) : '';
  const formattedEnd = parsedEnd ? formatDateWithShortWeekday(parsedEnd, endZone) : '';
  const timeRange = startDate !== endDate && endDate ? `${formattedStart} - ${formattedEnd}` : formattedStart;
  return timeRange;
};